///////////////////////////////////////////////////////////////////////////////////////
//                          Copyright (c) 2023 - 2023
//                           Coyote Logistics L.L.C.
//                         All Rights Reserved Worldwide
//
//WARNING:  This program (or document) is unpublished, proprietary
//property of Coyote Logistics L.L.C. and is to be maintained in strict confidence.
//Unauthorized reproduction, distribution or disclosure of this program
//(or document), or any program (or document) derived from it is
//prohibited by State and Federal law, and by local law outside of the U.S.
///////////////////////////////////////////////////////////////////////////////////////

import { pick } from "lodash";

export const handleCarrierMatchingValidations = (
  step,
  isBulkMatching,
  laneMatches
) => {
  let validationData = {};
  let allValid = true;
  let requiredFields = [];

  if (step === 2) {
    requiredFields = isBulkMatching
      ? ["odLoadingTypes", "equipmentType", "assetType", "weeklyCap"]
      : [
          "odLoadingTypes",
          "equipmentType",
          "assetType",
          "weeklyCap",
          "carrierRate"
        ];
  }

  if (step === 3) {
    requiredFields = [
      "odLoadingTypes",
      "equipmentType",
      "assetType",
      "weeklyCap",
      "carrierRate"
    ];
  }

  laneMatches?.forEach(laneMatch => {
    requiredFields.forEach(
      field =>
        laneMatch[field] || setValidationDataObj(field, true, validationData)
    );
  });

  allValid = Object.values(pick(validationData, ...requiredFields)).every(
    prop => prop.isError !== true
  );

  return allValid;
};

const setValidationDataObj = (field, isError, validationData) => {
  validationData[field] = {
    isError: isError
  };
};
